<template>
  <v-container fluid pa-0 ma-0 v-demo-show="{event:'welcome.journeyplan', show:!!totalMinutesRemaining && canShow}">
    <v-row justify="start" align="center" no-gutters>
      <v-col cols="auto">
        <v-btn fab
               small
               light
               elevation="0"
               @click="toggleJourneyPlan()"
        >
          <v-icon large color="primary">mdi-compass-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import applicationEventHub from "../../../events/applicationEventHub";

export default {
  name: "JourneyPlan",
  computed: {
    totalMinutesRemaining(){
      return this.$store.getters['assessment/minutesRemaining'];
    },
  },
  data() {
    return {
      canShow: true,
    }
  },
  methods: {
    toggleJourneyPlan() {
      if(this.$router.currentRoute.name==="Plan"){
        this.$router.back();
      }else{
        this.$router.push(`/journey/plan`).catch(() => {});
      }

    },
    makeShowable() {
      this.canShow = true;
    },
    makeNotShowable() {
      this.canShow = false;
    },
  },
  mounted() {
    applicationEventHub.$on('framework.question.timer.show',this.makeNotShowable);
    applicationEventHub.$on('framework.question.timer.hide', this.makeShowable);
  },
  beforeDestroy() {
    applicationEventHub.$off('framework.question.timer.show',this.makeNotShowable);
    applicationEventHub.$off('framework.question.timer.hide', this.makeShowable);
  }
}
</script>

<style scoped>

</style>